import { Sun, Calendar } from "lucide-react";
import { Link } from "react-router-dom";
import { useT } from "@/lib/i18n";

export default function Hero() {
  const { t } = useT();
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[100vh] hero-bg flex items-center"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/20 to-black/60" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 w-full pt-28 pb-16">
        <div className="max-w-3xl text-white animate-fade-up">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-6">
            <Sun className="h-4 w-4 text-sunset" />
            <span className="text-xs sm:text-sm font-semibold uppercase tracking-widest">
              {t("hero_badge")}
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-heading font-black tracking-tight text-white text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95]"
          >
            {t("hero_title_a")}
            <br />
            <span className="text-sunset">{t("hero_title_b")}</span>
            <br />
            {t("hero_title_c")}
          </h1>

          <p
            data-testid="hero-slogan"
            className="mt-8 text-2xl sm:text-3xl font-heading font-light text-white/95 italic"
          >
            {t("hero_slogan")}
          </p>

          <p className="mt-4 text-base sm:text-lg text-white/80 max-w-xl leading-relaxed">
            {t("hero_subtitle")}
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              data-testid="hero-register-btn"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-sunset text-white font-bold text-base sm:text-lg hover:bg-sunset-hover transition-all shadow-sunset hover:-translate-y-0.5"
            >
              <Calendar className="h-5 w-5" />
              {t("hero_book_btn")}
            </a>
            <Link
              to="/training"
              data-testid="hero-training-btn"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-white/10 backdrop-blur-md text-white font-semibold border border-white/30 hover:bg-white/20 transition-all"
            >
              {t("hero_contact_btn")}
            </Link>
          </div>

          <div className="mt-12 flex flex-wrap gap-x-10 gap-y-4 text-white/85">
            <Stat label={t("hero_stat_duration")} value="2" />
            <Stat label={t("hero_stat_hours")} value={t("hero_stat_hours_val")} />
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block">
        <div className="flex flex-col items-center gap-2 text-white/70 text-xs uppercase tracking-widest">
          <span>{t("hero_scroll")}</span>
          <div className="w-px h-10 bg-white/40" />
        </div>
      </div>
    </section>
  );
}

const Stat = ({ label, value }) => (
  <div>
    <div className="text-xs uppercase tracking-widest text-white/60">{label}</div>
    <div className="text-lg sm:text-xl font-heading font-bold text-white mt-1">
      {value}
    </div>
  </div>
);
